// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "中级财务管理",
      "tec": "王人杰",
      "week": "1-13周",
      "add": "教学楼D座227经管"
    },
    [
      {
        "sub": "税务会计",
        "tec": "何红",
        "week": "5-6周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "财务EXCEL",
        "tec": "郑新娜",
        "week": "7-10周",
        "add": "实训楼E座311西"
      }
    ],
    [
      {
        "sub": "内部审计",
        "tec": "刘英杰",
        "week": "1-13周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "佟玲",
        "week": "17周",
        "add": "教学楼D座125经管"
      }
    ],
    [
      {
        "sub": "能源电力工程与绿色低碳技术",
        "tec": "黄玉东张翼",
        "week": "1-8周",
        "add": "教学楼C座212教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "佟玲",
        "week": "17周",
        "add": "教学楼D座125经管"
      }
    ],
    0
  ],
  "2": [
    [
      {
        "sub": "财政学概论",
        "tec": "姜博",
        "week": "1-5周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "政府审计",
        "tec": "郑新娜",
        "week": "6-13周",
        "add": "教学楼D座227经管"
      }
    ],
    {
      "sub": "财务报表分析",
      "tec": "朱雅琴",
      "week": "1-12周",
      "add": "教学楼D座227经管"
    },
    [
      {
        "sub": "公司战略与风险管理",
        "tec": "陈涵慧",
        "week": "1-10周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "佟玲",
        "week": "17周",
        "add": "教学楼D座125经管"
      }
    ],
    [
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼A座321电力"
      },
      {
        "sub": "劳动与创造",
        "tec": "佟玲",
        "week": "17周",
        "add": "教学楼D座125经管"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "马彤兵",
      "week": "7-11周",
      "add": "教学楼D座226经管"
    }
  ],
  "3": [
    {
      "sub": "财务EXCEL",
      "tec": "郑新娜",
      "week": "1-12周",
      "add": "实训楼E座311西"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓王树平",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "中级财务管理",
        "tec": "王人杰",
        "week": "9-10周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "税务会计",
        "tec": "何红",
        "week": "11-12周",
        "add": "教学楼D座227经管"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "公司战略与风险管理",
        "tec": "陈涵慧",
        "week": "1-5周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "政府审计",
        "tec": "郑新娜",
        "week": "6-13周",
        "add": "教学楼D座227经管"
      }
    ],
    [
      {
        "sub": "财务报表分析",
        "tec": "朱雅琴",
        "week": "1-5,7-13周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "公司战略与风险管理",
        "tec": "陈涵慧",
        "week": "6周",
        "add": "教学楼D座227经管"
      }
    ],
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "中级财务管理",
      "tec": "王人杰",
      "week": "1-13周",
      "add": "教学楼D座227经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓王树平",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "内部审计",
        "tec": "刘英杰",
        "week": "9-11周",
        "add": "教学楼D座328经管"
      }
    ],
    [
      {
        "sub": "财政学概论",
        "tec": "姜博",
        "week": "1-7周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼D座417文法"
      }
    ],
    {
      "sub": "税务会计",
      "tec": "何红",
      "week": "1-12周",
      "add": "教学楼D座227经管"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
